module.exports = __webpack_public_path__ + "media/patterns/shattered-b434cf50.png";